import type { Session } from './auth.svelte';
import { resolveDemoPilotCredentials } from './hospital-preview.svelte';

const PILOT = import.meta.env.VITE_PILOT_MODE === 'true';
const DEMO_TENANT = import.meta.env.VITE_DEMO_TENANT ?? 'hosp-demo-pro';
const DEMO_USER = import.meta.env.VITE_DEMO_USER ?? 'hosp-demo-pro@toscanasystems.com';

export function isPilotMode(): boolean {
  return PILOT;
}

/** Obtiene sesión piloto desde el servidor (password solo en backend). */
export async function fetchPilotSession(
  tenantId?: string | null,
  usuario?: string | null,
): Promise<Session> {
  const tid = tenantId?.trim() || DEMO_TENANT;
  const usr = usuario?.trim() || DEMO_USER;
  const r = await fetch('/api/auth/v1/public/auth/pilot-session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ tenantId: tid, usuario: usr }),
  });
  if (!r.ok) {
    const txt = await r.text().catch(() => '');
    throw new Error(`Piloto: ${r.status} ${txt.slice(0, 200)}`);
  }
  const data = await r.json() as {
    token: string;
    tenantId: string;
    usuario: string;
    expiresIn: number;
    roles?: string[];
  };
  return {
    token: data.token,
    tenantId: data.tenantId ?? tid,
    usuario: data.usuario ?? usr,
    expiresAt: Date.now() + (data.expiresIn ?? 3600) * 1000,
    roles: data.roles ?? ['admin-tenant'],
    source: 'keycloak',
  };
}

let refreshPromise: Promise<Session | null> | null = null;

/** Renueva sesión piloto (deduplicado) — usar refreshPilotSession de auth.svelte.ts. */
export async function fetchPilotSessionDeduped(): Promise<Session | null> {
  if (!PILOT) return null;
  if (!refreshPromise) {
    refreshPromise = (async () => {
      const creds = resolveDemoPilotCredentials({ tenantId: DEMO_TENANT, usuario: DEMO_USER });
      return fetchPilotSession(creds.tenantId, creds.usuario);
    })().finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}
